<template>
	<div class="groups-list">
		<loading v-if="loading" class="group-loading"></loading>
		<no-content v-if="!loading && noGroups" :header="noContentHeader" :paragraph="noContentParagraph"></no-content>
		<ul v-else>
			<groups-list-item
				v-for="group in groupsDisplay"
				:group="group"
				@goToMessage="goToMessage"
				@goToMessageDirectly="goToMessageDirectly"
				:from="from"
				:key="group.groupID"
			></groups-list-item>
		</ul>
		<div
			v-if="from === 'groups'
            && additionalGroups
            && additionalGroups.length > 0
            && !loading"
		>
			<a class="more-groups" @click="showAllGroups">View more (+{{additionalGroups.length}})</a>
		</div>
		<!-- <hr v-if="from === 'groups'" /> -->
	</div>
</template>

<script>
import { db } from "../../resources/firebase";
import GroupsListItem from "./GroupsListItem.vue";
import Loading from "../errors/PageLoading.vue";
import NoContent from "../errors/NoContent.vue";

export default {
	data() {
		return {
			groupsDisplay: [],
			loading: true,
			groupsToShow: [],
			noGroups: false,
			noContentHeader: "You don't have any active discussions",
			noContentParagraph: "To begin a discussion click the button below"
		};
	},
	props: {
		from: {
			type: String
		}
	},
	components: {
		GroupsListItem,
		Loading,
		NoContent
	},
	created() {
		this.$store.subscribe((mutation, state) => {
			if (mutation.type === "addGroup" || mutation.type === "deleteGroup") {
				this.groupsToShow = [];
				this.groupsDisplay = [];
				this.displayGroups();
			}
		});
	},
	beforeMount() {
		this.displayGroups();
	},
	computed: {
		allUserGroups() {
			return this.$store.getters.getGroups;
		},
		additionalGroups() {
			if (this.allUserGroups && this.allUserGroups.length > 3) {
				return this.allUserGroups.slice(2, this.allUserGroups.length - 1);
			}

			return [];
		}
	},
	methods: {
		openModal() {
			const html = document.querySelector("html");
			const app = document.querySelector("#app");
			app.classList.add("blur-app");
			html.style.overflowY = "hidden";
		},
		showAllGroups() {
			this.openModal();

			//Set payload
			let payload = {
				show: true,
				from: "groups-list"
			};
			//Set state
			this.$store.commit("updateGroupsModal", payload);
		},
		displayGroups() {
			//Update groups to show
			if (this.allUserGroups && this.allUserGroups.length > 0) {
				this.groupsToShow.push(
					this.allUserGroups[0],
					this.allUserGroups[1],
					this.allUserGroups[2]
				);
			}

			if (this.from === "groups") {
				if (this.groupsToShow && this.groupsToShow.length > 0) {
					this.groupsToShow.forEach(group => {
						// In case all user groups is less than 3
						if (group !== undefined) {
							db.collection("test_groups")
								.doc(group)
								.get()
								.then(doc => {
									let data = doc.data();
									data.membersData = [];

									//Get each member's data
									data.members.forEach(member => {
										let memberID =
											typeof member === "string" ? member : member.objectID;
										db.collection("users")
											.doc(memberID)
											.get()
											.then(docData => {
												data.membersData.push(docData.data());
											})
											.catch(error => {
												// console.log(error);
												throw new Error(error);
											});
									});

									setTimeout(() => {
										this.groupsDisplay.push(data);
										this.loading = false;
									}, 1500);
								})
								.catch(error => {
									// console.log(error);
									throw new Error(error);
								});
						}
					});
				}
			} else if (this.from === "groups-modal") {
				if (this.allUserGroups.length > 0) {
					this.allUserGroups.forEach(group => {
						let getGroups = new Promise((resolve, reject) => {
							db.collection("test_groups")
								.doc(group)
								.get()
								.then(doc => {
									let data = doc.data();
									data.membersData = [];

									//Get each member's data
									data.members.forEach(member => {
										let memberID =
											typeof member === "string" ? member : member.objectID;
										db.collection("users")
											.doc(memberID)
											.get()
											.then(docData => {
												data.membersData.push(docData.data());
											})
											.catch(error => {
												// console.log(error);
												throw new Error(error);
											});
									});

									resolve(data);
								})
								.catch(error => {
									// console.log(error);
									reject(new Error(error));
								});
						});

						getGroups
							.then(data => {
								setTimeout(() => {
									this.groupsDisplay.push(data);
									this.loading = false;
								}, 1500);
							})
							.catch(error => {
								// console.log(error);
								throw new Error(error);
							});
					});
				} else {
					this.loading = false;
					this.noGroups = true;
				}
			}
		},
		goToMessage(group) {
			//Set payload
			let payload = {
				show: true,
				from: "groups-list",
				group: group
			};
			//Set state
			this.$store.commit("updateGroupsModal", payload);
			this.$emit("goToMessage", group);
		},
		goToMessageDirectly(group) {
			//Set payload
			let payload = {
				show: true,
				from: "groups",
				group: group
			};
			//Set state
			this.$store.commit("updateGroupsModal", payload);
			this.openModal();
		}
	}
};
</script>

<style scoped>
.group-loading {
	position: relative !important;
	margin-bottom: 10px;
}

ul {
	padding: 0px 10px;
	max-height: 350px;
	overflow: auto;
	margin-bottom: 20px;
}

ul li:not(:last-of-type) {
	border-bottom: 1px solid #111;
	/* padding-bottom: 15px; */
}

hr {
	background-color: #111;
	height: 1px;
	margin: 0 0 15px;
}

.more-groups {
	text-align: center;
	display: block;
	font-size: 12px;
	font-weight: bold;
	color: #51c715;
	text-decoration: underline;
	margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/groups/GroupsList.vue